export const notificationType = {
  success: 'success',
  info: 'info',
  warning: 'warning',
  error: 'error'
};
